<template :style="$i18n.locale=='en' ? 'direction:ltr' : 'direction:rtl'">
  <div
    class="c-app flex-row align-items-center"
    style="
      background-image: url('../../../img/img(11).jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    "
  >
    <!--<img src="../../assets/image/loginBack.jpg"/>-->
    <CContainer
      :style="$i18n.locale == 'en' ? 'direction:ltr' : 'direction:rtl'"
    >
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCardGroup>
            <CCard class="pt-0 px-4" style="opacity: 0.8">
              <CCardBody>
                <CAlert
                  :show.sync="dismissCountDown"
                  closeButton
                  color="warning"
                  fade
                >
                  <strong class="rounded-circle mx-2 text-info">{{
                    dismissCountDown
                  }}</strong>
                  {{ alertText }}
                </CAlert>
                <CForm class="needs-validation">
                  <CRow class="mb-2">
                    <CImg
                      src="../../../img/icon.png"
                      class="col-4"
                      align="center"
                    ></CImg
                  ></CRow>
                  <CRow v-if="spinner" class="justify-content-center mt-2">
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </CRow>

                  <h5 class="text-center">تغییر رمزعبور</h5>
                  <p class="text-muted text-center">
                    رمزعبور خود را بصورت دوره ای تغییر دهید.
                  </p>
                  <CRow>
                    <CInput
                      label="رمزعبور فعلی"
                      required
                      type="password"
                      v-model="info.oldPassword"
                      :value="info.oldPassword"
                    />
                  </CRow>

                  <CRow>
                    <CInput
                      id="password"
                      label="رمزعبور جدید"
                      type="password"
                      required
                      v-model="info.newPassword"
                      :value="info.newPassword"
                    />
                    <CInput
                      label="تکرار رمزعبور جدید"
                      type="password"
                      required
                      v-model="info.rePassword"
                      :value="info.rePassword"
                    />
                  </CRow>

                  <CRow class="justify-content-center mt-3">
                    <CButton
                      @click="changePassword()"
                      class="col mx-1 btn-primary"
                      ><CIcon name="cil-check-circle" />تایید</CButton
                    >
                    <CButton class="col mx-1 btn-danger" @click="clear()"
                      ><CIcon name="cil-check-circle" />پاک کردن</CButton
                    >
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف ساختار سازمانی'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف ساختار سازمانی'"
          @click="deleteOrganizationalStructure"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import router from "../../router";
import axios from "axios";
import { Values } from "../../commonValues.js";
import { setAuthToken } from "../../services/AuthService.js";
export default {
  name: "Login",

  //****************************************************************************************** data */
  data() {
    return {
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      info: {
        oldPassword: "",
        newPassword: "",
        rePassword: "",
      },

      userName: localStorage.getItem("username"), //read from local storage

      dismissCountDown: 0,
      alertText: "",
      spinner: false,
    };
  },

  //*****************************************************************************************/ mounts
  mounted() {
    //const config = { headers: { "Content-Type": "application/json",'Access-Control-Allow-Origin' : '*', } };
    // { withCredentials: true } or axios.defaults.withCredentials = true
    //console.log("Page hostname is " + window.location.hostname);
    //console.log(this.$route.query.username);
    window.addEventListener("popstate", this.handleBackButton); //back event
  },

  beforeDestroy() {
    //back event
    window.removeEventListener("popstate", this.handleBackButton);
  },

  //***************************************************************************************** components */
  components: {},

  //****************************************************************************************** methods */
  methods: {
    handleBackButton(event) {
      console.log("back clicked!!!");
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("image");
      localStorage.removeItem("changePasswordStatus");
      delete axios.defaults.headers.common["Authorization"];
      router.push({ name: "Home" });
    },
    //**************************************************************************************** */
    changePassword() {
      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;

      var passwordFormat =
        /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,100}$/;
      let passwordValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].id == "password" &&
          forms[0][i].required &&
          //forms[0][i].value == ""
          !forms[0][i].value.match(passwordFormat)
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          //formValid = false;
          passwordValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "textarea" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      if (formValid == true && passwordValid == true) {
        if (this.info.newPassword == this.info.rePassword) {
          axios
            .post(Values.serverIp + "User/ChangeUserPassword", {
              userName: this.userName,
              oldPassword: this.info.oldPassword,
              newPassword: this.info.newPassword,
            })
            .then((response) => {
              //console.log(response.data);
              if (response.status == 200 && response.data == "0") {
                // modal successfuly
                this.alertModal = true;
                this.alertModalTitle = "تغییرات";
                this.alertModalText = "تغییرات با موفقیت انجام شد.";
                this.alertModalColor = "success";
                this.alertModalButtonText = "تایید";
                localStorage.removeItem("token");
                localStorage.removeItem("username");
                delete axios.defaults.headers.common["Authorization"];
                router.push({ name: "Home" });
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                if (response.data == "1") {
                  this.alertModalText = "رمز عبور فعلی اشتباه می باشد.";
                } else {
                  this.alertModalText = "لطفا دوباره تلاش نمایید.";
                }
                this.alertModalColor = "warning";
                this.alertModalButtonText = "تایید";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.dismissCountDown = 8;
          this.alertText = "رمزعبور جدید وارد شده و تکرار آن هم خوانی ندارد.";
        }
      } else {
        this.dismissCountDown = 8;
        if (formValid != true) {
          this.alertText = "لطفا تمامی موارد را تکمیل نمایید.";
        } else if (passwordValid != true) {
          this.alertText =
            "رمزعبور باید حداقل 8 کاراکتر بوده و شامل حروف کوچک و بزرگ انگلیسی ، حداقل یک عدد و شامل کاراکترهای خاص (!@#$%^&*) باشد.";
        }
      }
    },

    clear() {
      this.info.oldPassword = "";
      this.info.newPassword = "";
      this.info.rePassword = "";
    },
  },
  //***************************** */ end methods
};
</script>


